import { createSelector } from 'reselect'

const getOnboardingData = state => state.onboarding

const onboardingViewSelector = createSelector(
	[getOnboardingData],
	onboarding => ({
		exitComplete: onboarding.loopComplete > 1 && onboarding.loadedAssets === 8 && onboarding.loadingComplete,
	})
)

export default onboardingViewSelector
